


























import { Component, Vue, Prop } from 'vue-property-decorator';
import { hideLoading, showLoading } from '@/fit-components/loading/main';
import { showBusinessError } from '@/fit-components/dialog/main';
import VHeader from '../components/sub-header.vue';
import VTable from '../components/table.vue';
import { NcovDataType } from '../types';
import { util, biHottag, language } from '@tencent/ppd-base-libs';
import { i18n } from '@/i18n';
import LoadFailed from '@/components/load-failed.vue';

@Component({
  components: { VHeader, VTable, LoadFailed },
})
export default class AreaTable extends Vue {
  loadFailed = false;
  lang = language.getLanguage();
  tabelCols = [
    {
      title: i18n('出入境管制站'),
      key: 'station',
      width: '50%',
      color: '#373737',
    },
    {
      title: i18n('辦公時間'),
      key: 'time',
      width: '50%',
      color: '#373737',
    },
  ];

  tabelData = [
    {
      station: i18n('香港國際機場'),
      time: i18n('一號客運大樓全日24小時'),
    },
    {
      station: i18n('深圳灣'),
      time: i18n('10:00～20:00'),
    },
    {
      station: i18n('港珠澳大橋'),
      time: i18n('旅檢大樓-私家車'),
    },
    {
      station: i18n('羅湖'),
      time: i18n('暫停旅客清關服務'),
    },
    {
      station: i18n('紅磡'),
      time: i18n('暫停旅客清關服務'),
    },
    {
      station: i18n('落馬洲'),
      time: i18n('暫停旅客清關服務'),
    },
    {
      station: i18n('落馬洲支線'),
      time: i18n('暫停旅客清關服務'),
    },
    {
      station: i18n('文錦渡'),
      time: i18n('暫停旅客清關服務'),
    },
    {
      station: i18n('沙頭角'),
      time: i18n('暫停旅客清關服務'),
    },
    {
      station: i18n('中國客運碼頭'),
      time: i18n('暫停旅客清關服務'),
    },
    {
      station: i18n('港澳客輪碼頭'),
      time: i18n('暫停旅客清關服務'),
    },
    {
      station: i18n('屯門客運碼頭'),
      time: i18n('暫停旅客清關服務'),
    },
    {
      station: i18n('啓德郵輪碼頭'),
      time: i18n('暫停旅客清關服務'),
    },
    {
      station: i18n('高鐵西九龍'),
      time: i18n('暫停旅客清關服務'),
    },
  ];

  get cols() {
    return this.tabelCols;
  }
  get dataset() {
    return this.tabelData;
  }
  goEntryService() {
    biHottag('wallet.cvirus.ctrlpoints.psngtraffic_click'); // 疫情首页-管制站安排页-出入境人次
    setTimeout(() => {
      if (this.lang === 'en') {
        window.location.href = 'https://www.immd.gov.hk/eng/message_from_us/stat_menu.html';
      } else {
        window.location.href = 'https://www.immd.gov.hk/hks/message_from_us/stat_menu.html';
      }
    }, 300);
  }
  goAirportService() {
    biHottag('wallet.cvirus.ctrlpointst.qrntnprocedure_click'); // 疫情首页-管制站安排页-机场入境检疫程序
    setTimeout(() => {
      if (this.lang === 'en') {
        window.location.href = 'https://www.coronavirus.gov.hk/eng/quarantine_procedures_airport.html';
      } else {
        window.location.href = 'https://www.coronavirus.gov.hk/chi/quarantine_procedures_airport.html';
      }
    }, 300);
  }
  async activated() {
    showLoading();
    window.scrollTo(0, 0);
    this.loadFailed = false;
    util.changeTitle(i18n('旅客管制站安排'));
    biHottag('wallet.cvirus.ctrlpoints.index_brow'); // 核酸机构列表页
    hideLoading();
  }
  deactivated() {}
}
